// Module
var code = `<div class="editor-container" ng-non-bindable>
  <div class="editor-toolbar"></div>
  <div class="editor"></div>
</div>


<div class="alert" ng-if="\$ctrl.initializationStatus === 'LOADING'">
  Loading html editor
</div>

<div class="alert alert--danger" ng-if="\$ctrl.initializationStatus === 'FAILED'">
  Html editor failed to load
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/wysiwyg-editor/wysiwyg-editor.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;